// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__3LnLK","footer__links":"Footer_footer__links__he8bl","footer__col":"Footer_footer__col__-TpFh","footer__bottom":"Footer_footer__bottom__lllJg"};